<template>
  <div class="main-container">
    <router-view></router-view>
    <live-chat></live-chat>
    <vue-snotify></vue-snotify>
    <loading
      :active.sync="isLoading.length > 0"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </div>
</template>

<script>
import Vue from 'vue';
import polyfill from 'babel-polyfill';
import { EventBus } from './event-bus';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import LiveChat from './components/chat/UserChat.vue';
import CKEditor from '@ckeditor/ckeditor5-vue';
import SwitchLang from './components/SwitchLang.vue';

Vue.component('SwitchLang', SwitchLang);
Vue.component('loading', Loading);
Vue.component('live-chat', LiveChat);
Vue.use( CKEditor );

Vue.use(Snotify, {
  toast: { position: SnotifyPosition.leftBottom, showProgressBar: false, maxOnScreen: 1},
});

export default {
  name: 'App',
  data() {
    return {
      isLoading: [],
    };
  },
  created() {
    const self = this;

    EventBus.$on('showThrobber', function() {
      self.isLoading.push(true);
    });
    EventBus.$on('hideThrobber', function() {
      self.isLoading.pop(true);
    });
    EventBus.$on('error', function(data) {
      this.$snotify.error(data.msg);
    });
    EventBus.$on('success', function(data) {
      this.$snotify.success(data.msg);
    });
    EventBus.$on('warning', function(data) {
      this.$snotify.warning(data.msg);
    });
  },
};
</script>

<style lang="scss">
@import '~vue-snotify/styles/material.scss';
@import '~vali-admin/src/sass/main.scss';
@import './assets/sass/main.scss';
@import './assets/sass/validation.scss';
@import './assets/sass/tooltip.scss';
</style>
